import React from "react";
import Modal from "../AbstractModal/AbstractModal";
import AdministratorForm from "~/components/forms/AdministratorForm/AdministratorForm";

export default ({ administratorId }: { administratorId: string }) => (
  <Modal title={`${administratorId ? 'Edit' : 'Add'} Administrator`} className='AdministratorModal'>
    <div><AdministratorForm administratorId={administratorId} /></div>
  </Modal>
);